import React from 'react';
import Modal from '../../../components/Modal';
import LenderUgroService from '../../../services/lender';
import { Context } from '../../../config/store';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router';
import message from '../../../constant/message';
import Button from '../../../components/Common/Button';

const DisburseModal = ({
    modelState,
    detailLenderId,
    detailLenderName,
    toggleModal
}) => {
    const navigate = useNavigate();
    const { state } = React.useContext(Context);
    const [loading, setLoading] = React.useState(false);
    const leadId = useParams()['id'];

    const changeStatus = async () => {
        setLoading(true);
        try {
            const response = await LenderUgroService.disbursedChangeStatus(
                state.userType,
                leadId,
                detailLenderId,
            );
            const success = response?.data?.messages?.success;
            toast.success(
                success?.form?.[0] || success?.others?.[0] || message.SAVED_SUCCESS
            );
            navigate('/portfolio/disbursal-approved');
        } catch (err) {
            let error = err?.response?.data?.messages?.error;
            toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
        }
        setLoading(false);
    };

    return (
        <Modal state={modelState} closeModal={toggleModal}>
            <div>
                <p className='font-weight-bold text-center'>
                    {detailLenderId == 23 ? 'Is the LAF disbursed from ' : 'Do you want to Disburse this application with '}
                    {detailLenderName} ?
                </p>
                <div className='d-flex align-items-center justify-content-center mt-2'>
                    <Button
                        clickHandler={toggleModal}
                        classNames='btn-custom small mr-2'
                    >
                        No
                    </Button>
                    <Button clickHandler={changeStatus} classNames='btn-custom small' disabled={loading}>
                        {loading ? <div className='loader' /> : 'Yes'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default DisburseModal;
